import {RequestForm_FieldTreatAs} from "../../../../app/tools/request-forms2/const/const"
import {MandatoryFieldsIds} from "../../../../app/tools/request-forms2/@const"
import RequestFormField from "../settings/field"

// const debug = "autoSetTreatAsFroOldFields"
const debug = false

export function autoSetTreatAsFroOldFields(fields:RequestFormField[]) {

    debug && console.log(debug, 'process', fields)

    const hasFieldTreatedAsName = _.find(fields, (requestFormField: RequestFormField) => requestFormField.treatAs === RequestForm_FieldTreatAs.USER_NAME)
    if (!hasFieldTreatedAsName) {
        debug && console.log(debug, 'process add treatAs name')

        const emailField = _.find(fields, (requestFormField: RequestFormField) => requestFormField.formFieldConfig?.fieldId === MandatoryFieldsIds.NAME)
        if (emailField) emailField.treatAs = RequestForm_FieldTreatAs.USER_NAME
    }

    const hasFieldTreatedAsEmail = _.find(fields, (requestFormField: RequestFormField) => requestFormField.treatAs === RequestForm_FieldTreatAs.USER_EMAIL)
    if (!hasFieldTreatedAsEmail) {
        debug && console.log(debug, 'process add treatAs email')

        const emailField = _.find(fields, (requestFormField: RequestFormField) => requestFormField.formFieldConfig?.fieldId === MandatoryFieldsIds.EMAIL)
        if (emailField) emailField.treatAs = RequestForm_FieldTreatAs.USER_EMAIL
    }
}